/**
 * TanStack Query hook for fetching game providers
 * 
 * OPTIMIZATION: This query now uses the unified /lobby/init endpoint via useLobbyInitQuery
 * which fetches categories, providers, live-categories, and jackpot data in a single request.
 */

import { useLobbyInitQuery } from './useLobbyInitQuery';

/**
 * Fetch list of game providers
 * 
 * Provider list changes rarely (when admin adds new providers),
 * so we cache for 60 minutes.
 * 
 * OPTIMIZATION: Uses the unified /lobby/init endpoint via useLobbyInitQuery to reduce API calls.
 */
export function useProvidersQuery() {
  const { data, isLoading, error, refetch } = useLobbyInitQuery();
  
  return {
    data: data?.providers || [],
    isLoading,
    error,
    refetch,
  };
}
